export default __webpack_public_path__ + "static/9-a14820bb539a7d15a31df0dd1c8e6097.png";